import Ui from '../../../client/client-ui'

export default class Login
{
	static check = function(email, password)
	{
		Ui.post('/login/', {
			email   : email,
			password: password,
		}, (success) =>
		{
			if(success)
			{
				setTimeout(() => window.location.reload(), 1000)
			}
		})
	}
}
